import { LoanProductType } from "../../hooks/api/types";
import { LoanCalculatorReducerAction, LoanCalculatorState } from "./types";

export const LoanCalculatorReducer = (
  state: LoanCalculatorState,
  action: LoanCalculatorReducerAction
): LoanCalculatorState => {
  switch (action.type) {
    case "SET_FIXED_TERM_LOAN":
      return {
        ...state,
        type: LoanProductType.FIXED_TERM,
        fixedTermLoan: action.payload,
        loading: false,
      };
    case "SET_INVOICE_DISCOUNTING_LOAN":
      return {
        ...state,
        type: LoanProductType.INVOICE_DISCOUNTING,
        invoiceDiscountingLoan: action.payload,
        loading: false,
      };
    case "SET_PAYABLE_FINANCING_LOAN":
      return {
        ...state,
        type: LoanProductType.PAYABLE_FINANCING,
        payableFinancingLoan: action.payload,
        loading: false,
      };
    case "SET_REVENUE_BASED_LOAN":
      return {
        ...state,
        type: LoanProductType.REVENUE_BASED_FINANCING,
        revenueBasedLoan: action.payload,
        loading: false,
      };
    case "SET_BNPL_LOAN":
      return {
        ...state,
        type: LoanProductType.BNPL,
        buyNowPayLaterLoan: action.payload,
        loading: false,
      };
    case "SET_CONSTRAINTS":
      return {
        ...state,
        constraints: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
